import { render, staticRenderFns } from "./SuperTableAssign.vue?vue&type=template&id=670f69a7"
import script from "./SuperTableAssign.vue?vue&type=script&lang=js"
export * from "./SuperTableAssign.vue?vue&type=script&lang=js"
import style0 from "./SuperTableAssign.vue?vue&type=style&index=0&id=670f69a7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports